// @ts-strict-ignore
import { JsonObject } from '@shared/convert/convert-core';

@JsonObject('ElbridgeDataContainerVO')
export class ElbridgeDataContainerVO {
  public CONFIGURATION_URL;
  public ITEM;
  public MIME;
}
